import { render, staticRenderFns } from "./goodsNum.vue?vue&type=template&id=f36a768c&scoped=true"
import script from "./goodsNum.vue?vue&type=script&lang=js"
export * from "./goodsNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36a768c",
  null
  
)

export default component.exports